const routes = {
  '/app/team': {
    fetch: () =>
      import(/* webpackChunkName: 'team-route' */ 'app/team/asyncRoute').then(
        module => module.default
      ),
  },
};

export default routes;
